import { dom, library, config  } from '@fortawesome/fontawesome-svg-core'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { faLanguage,
    faGlobe,
    faSitemap,
    faEnvelope,
    faLock,
    faUser,
    faUserTie,
    faBuilding,
    faBuildings,
    faUsers,
    faClock,
    faCreditCard,
    faMemoCircleInfo,
    faCircleInfo,
    faKey,
    faCopy
} from '@fortawesome/pro-light-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

config.autoReplaceSvg = 'nest'

library.add(fas, far, fab, {
    faLanguage,
    faGlobe,
    faSitemap,
    faEnvelope,
    faLock,
    faUser,
    faUserTie,
    faBuilding,
    faBuildings,
    faUsers,
    faClock,
    faCreditCard,
    faMemoCircleInfo,
    faCircleInfo,
    faKey,
    faCopy,
})

document.addEventListener("DOMContentLoaded", function() {
    dom.i2svg()

    dom.watch({
        autoReplaceSvgRoot: document,
        observeMutationsRoot: document.body
    })
})
